<section class="content">
  <div class="container-fluid">
    <div *ngIf="!is_counter_selected">
      <div class="card" style="    padding: 24px;">
      <div style="margin-top: 2%;">
        <label style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">Select the counter you are going to work today</label>
      </div>
      <div class="row">
        <div class="col-sm-12 col-lg-7 col-md-7">
          <div class="row">
            <div class="border-item col-4" style="font-weight: bold;">Collection Center</div>
            <div class="border-item col-4" style="font-weight: bold;">Counter Name</div>
            <div class="border-item col-4" style="font-weight: bold;">Login users</div>
          </div>
          <div class="row" *ngFor="let center of collection_center">
            <div class="border-item col-4">{{center}}</div>
            <div class="col border-item">
              <div class="row" *ngFor="let counter of counter_list[center]">
                <div class="col border-item"><button mat-button
                    style="background: aquamarine; border-radius: 15px; margin-top: 10px;"
                    (click)="counterClicked(counter.counter_id)"
                    [disabled]="logged_user_befere_select_counter.hasOwnProperty(counter.counter_id)">{{counter['counter_name']}}</button>
                </div>
                <div class="col border-item">
                  <span *ngIf="logged_user_befere_select_counter.hasOwnProperty(counter.counter_id)">
                    {{logged_user_befere_select_counter[counter.counter_id]['employee_name']}} at
                    {{logged_user_befere_select_counter[counter.counter_id]['start_date_time'] | date: 'shortTime'}}
                  </span>
                  <span *ngIf="!logged_user_befere_select_counter.hasOwnProperty(counter.counter_id)">
                    No one
                  </span>
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form-row" *ngIf="is_counter_selected">
      <div class="col">
        <label style="font-size: 15px;">Enter Customer and Search <i class="material-icons"
            style="color: red;font-size: 14px;">star</i></label>
        <input type="text" class="form-control" [(ngModel)]="icustomer_code" id="customer_code"
          (keydown)="eventEmitClickedOnCustmerCode($event, 'code')"
          style="padding: 5px; border-bottom: none; border: 3px solid black; border-radius: 5px; ;height: 68%; font-size: 20px;">
      </div>
      <div class="col-1 text-center" style="font-size: 28px; margin-top: 3%;">or</div>
      <div class="col">
        <label style="font-size: 15px;">Enter Customer Phone number and Search <i class="material-icons"
            style="color: red;font-size: 14px;">star</i></label>
        <input type="text" class="form-control" [(ngModel)]="icustomer_mobile"
          (keydown)="eventEmitClickedOnCustmerPhone($event, 'phone_number')" id="customer_phone_number"
          style="padding: 5px; border-bottom: none; border: 3px solid black; border-radius: 5px; ;height: 68%; font-size: 20px;">
      </div>
      <div class="col">
        <button mat-raised-button color="primary" class="button-class"
          style="margin-left: 10%;margin-top: 13%;font-size: 20px;" (click)="getIcustomerDetails()"
          [disabled]="icustomer_code == null && icustomer_mobile == null">Search
        </button>
      </div>
    </div>
    <div class="row" *ngIf="is_counter_selected " style="margin-top: 4%;">
      <div class="col-lg-7">
        <div *ngIf="icustomer_verified" style="padding: 13px;">
          <div class="card" *ngIf="next_month_order_avaliable.is_order_placed == true" style="margin-top: -10px; padding: 20px; color: blue;">

            <h1>{{next_month_order_avaliable.next_month_in_string}} month's order has been placed on {{next_month_order_avaliable.order_placed_on | date:'MMM d, y'}}.</h1> <br>

            <h1>For {{next_month_order_avaliable.order_month_in_string}} you can order only from {{next_month_order_avaliable.next_month_in_string}} 1st.</h1>

          </div>
          <div class="card" *ngIf="(product_form_dict != null) && (next_month_order_avaliable.is_order_placed == false)" style="margin-top: -10px; padding: 20px;">
            <div class="row">
              <div class="col-1"></div>
              <div class="col text-center" style="font-weight: 600; font-size: 18px;"><b>Order Details</b></div>
              <div class="col-2"></div>
            </div>
            <hr>
            <div class="row">
              <div class="col-1"></div>
              <div class="col-5" style="font-weight: 600;">
                {{monthNames[next_month_value_in_number]}} {{total_days_in_next_month}} days
              </div>
              <div class="col" style="text-align: center; font-size: 15px;">{{total_quantity}}L / {{milk_limit}}L<br>
                <p *ngIf="total_quantity > milk_limit" style="color: red;">Max limit reached</p>
              </div>
            </div>

            <div class="row" style="text-align: center; font-size: 20px;">
              <div class="col-5"></div>
              <div class="col-2 text-center" *ngFor="let session of session_list">
                {{session['display_name']}}
              </div>
              <div class="col">
                <label> Price<br>(Per month)</label>
              </div>
            </div>

            <div class="row">
            </div>
            <span *ngIf="product_form_dict.hasOwnProperty('product')">
              <span *ngFor="let product of product_list; let product_index=index">
                <div class="row" style="margin-top: 10px;"
                  *ngIf="icustomer_type_id == 2 && old_employee_product_list.includes(product.product_id)">
                  <div class="col-1"></div>
                  <div class="col-4">
                    {{product.product_short_name}}<br>
                    {{product.product_mrp | currency:'INR'}}
                  </div>
                  <div class="col-2" *ngFor="let session of session_list" style="text-align: center;">
                    <input type="tel" style="border: 1px solid; padding: 2px;  height: 30px;" placeholder="0" [min]="0"
                      id="{{session.id}}_{{product_index}}"
                      (keyup)="eventEmitOnInput(session.id, product_index, $event)"
                      onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"
                      [(ngModel)]="product_form_dict['product'][session.id][product.product_id]['quantity']"
                      (ngModelChange)="productQuantityChanged(session.id, product.product_id, product.product_mrp)"
                      [disabled]="!product_availability[session.id][product.product_id]"
                      [style.border-color]="product.color"
                      [style.background]="!product_availability[session.id][product.product_id] ? 'lightgray': 'none'">
                  </div>
                  <div class="col" style="text-align: left;" style="text-align: center;">
                    <label style="margin-left: 5%;">
                      {{product_form_dict['total_price_per_product_per_month'][product.product_id]}}
                    </label>
                  </div>
                </div>

                <div class="row" style="margin-top: 10px;" *ngIf="icustomer_type_id !== 2">
                  <div class="col-1"></div>
                  <div class="col-4">
                    {{product.product_short_name}}<br>
                    {{product.product_mrp | currency:'INR'}}
                  </div>
                  <div class="col-2" *ngFor="let session of session_list" style="text-align: center;">
                    <input type="tel" style="border: 1px solid; padding: 2px;  height: 30px;" placeholder="0" [min]="0"
                      id="{{session.id}}_{{product_index}}"
                      (keyup)="eventEmitOnInput(session.id, product_index, $event)"
                      onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"
                      [(ngModel)]="product_form_dict['product'][session.id][product.product_id]['quantity']"
                      (ngModelChange)="productQuantityChanged(session.id, product.product_id, product.product_mrp)"
                      [disabled]="!product_availability[session.id][product.product_id]"
                      [style.border-color]="product.color"
                      [style.background]="!product_availability[session.id][product.product_id] ? 'lightgray': 'none'">
                  </div>
                  <div class="col-2" style="text-align: right;">
                    <label style="margin-left: 5%;">
                      {{product_form_dict['total_price_per_product_per_month'][product.product_id] | currency: 'INR'}}
                    </label>
                  </div>
                  <div class="col-1"></div>
                </div>
              </span>
            </span>
            <div class="row" style="font-size: 25px;">
              <div class="col-9" style="text-align: right;">
                <label style="font-size: 20px;">Total price</label>
              </div>
              <div class="col-2" style="text-align: center; border-top: 1px solid; border-bottom: 1px solid;">
                <label
                  style="margin-left: 5%; font-size: 17px;">{{product_form_dict['total_price_per_order'] | currency:'INR'}}</label>
              </div>
            </div>
            <div *ngIf="product_form_dict['total_price_per_order']!=0 && icustomer_verified && icustomer_type_id != 2"
              style="text-align: center;">
              <div class="row">
                <div class="col" style="text-align: center;">
                  <button mat-raised-button class="button-class" (click)="payClicked()" id="confirm_button"
                    style="margin-top: 3px;" [disabled]="disable_button"> <mat-spinner [diameter]="40" *ngIf="disable_button"></mat-spinner> Pay
                    {{product_form_dict['total_price_per_order'] | currency:'INR'}}
                  </button>
                </div>
              </div>
            </div>
            <div *ngIf="icustomer_type_id == 2 && icustomer_verified" style="text-align: center;">
              <div class="row">
                <!-- <div class="col-2" *ngIf="disable_button">
                  <mat-spinner [diameter]="40"></mat-spinner>
                </div> -->
                <div class="col" style="text-align: center;">
                  <button mat-raised-button class="button-class" (click)="payClicked()" id="confirm_button"
                    style="margin-top: 3px;" [disabled]="disable_button">  <mat-spinner [diameter]="40" *ngIf="disable_button"></mat-spinner> Pay
                    {{product_form_dict['total_price_per_order'] | currency:'INR'}}
                  </button>
                </div>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="col-1"></div>
              <div class="col text-center" style="font-weight: 600; font-size: 18px;">
                Current Delivery Point
              </div>
              <div class="col-2"></div>
            </div>
            <hr>
            <div class="row" *ngIf="business_details!=null" style="padding: 10px;">
              <div class="col-1"></div>
              <div class="col">
                <b>Booth Name : </b> {{business_details['name']}}<br>
                <b> Agent Name : </b> {{business_details['agent_first_name']}}
                {{business_details['agent_last_name']}}<br>
                <b>Mobile : </b> {{business_details['agent_mobile_number']}}<br>
                <b>Address : </b> {{business_details['address']}} ,
                {{business_details['location_category_value']}} , {{business_details['location_category_name']}}
              </div>
              <div class="col-3"> <button mat-raised-button class="button-class"
                  (click)="boothChangeClicked('edit')">Change</button></div>
            </div>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="card" *ngIf="icustomer_verified"
          style="box-shadow: 0px 0px 5px 0px #535252; padding: 15px; background: #fff8ed;">
          <div class="row">
            <div class="col-1"></div>
            <div class="col text-center" style="font-weight: 600; font-size: 18px;">
              Customer Details &nbsp;&nbsp;
              <button (click)="icustomerPesonalDetails()" mat-raised-button class="button-class">Edit</button>
            </div>
            <div class="col-1">
            </div>
          </div>
          <hr>
          <div class="row">
            <div class="col">
              {{ icustomer_detail['first_name'] }}
              {{ icustomer_detail['last_name'] }}({{icustomer_detail['icustomer_code']}})
            </div>
            <div class="col">
              {{ icustomer_detail['mobile'] }}
            </div>
            <div class="col-5">
              <b>Cust. Type</b> : {{ icustomer_detail['customer_type_name'] }}
            </div>
          </div>
          <div class="row">
            <div class="col">
              <b>Address</b> : {{ icustomer_detail['address'] }} - {{ icustomer_detail['pincode'] }}
            </div>
            <div class="col-5">
              <b>Cust. Wallet</b> : {{ icustomer_detail['wallet_amount'] }}
            </div>
          </div>
        </div>
        <div style="background: #efeeec; padding: 10px; color: gray;overflow: auto; height: 600px;">
          <div class="row">
            <div class="col" style="text-align: center; font-size: 22px;">
              {{counter_name}} , {{today_date_time | date: 'EEEE, MMM d'}}<br>
              Total Amount - {{total_amount_in_counter | currency: 'INR'}} &nbsp;&nbsp; Count :
              {{total_booth_count}} <br>
              Wallet Amount Used - {{total_amount_used_via_wallet | currency: 'INR'}}
            </div>
          </div>
          <hr style="background: white;">
          <div class="row" style="font-size: 20px; color: #6fbebe;">
            <div class="col-3">Name</div>
            <div class="col-2">B.Code</div>
            <div class="col-2" style="text-align: center !important;">Amount</div>
            <div class="col-3">Ord.time</div>
            <div *ngIf="!is_deteted" class="col-2">
              <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="50">
              </mat-progress-spinner>
            </div>
          </div>
          <div class="row" *ngFor="let user of login_users" style="font-size: 15px;">
            <div class="col-12" style="margin-bottom: 10px;">
              <div class="row">
                <div class="col"><span style="font-weight: bold;">{{user['employee_name']}}</span><span
                    style="font-style: italic;">
                    ({{user['login_time']| date: 'shortTime'}} to <span
                      *ngIf="user.logout_time != 0 ">{{user['logout_time'] | date: 'shortTime'}}</span><span
                      *ngIf="user.logout_time == 0 ">Now</span> )
                  </span></div>
              </div>
            </div>
            <div class="col-12">
              <span *ngIf="sale_group_data.hasOwnProperty(user.login_id)">
                <div class="row" *ngFor="let sale_data of sale_group_data[user.login_id]"
                  style="margin-bottom: 10px !important; color: #6fbebe; margin-left: 0%;">
                  <!-- <div class="col-1"></div> -->
                  <div class="col-3">{{sale_data['customer_first_name'] | slice : 0:6 }} &nbsp; <span
                      style="font-style: italic;">{{sale_data['date']| date: 'MMM'}}</span></div>
                  <div class="col-2">{{sale_data['business_code']}}</div>
                  <div class="col-2" style="text-align: right!important;">
                    {{sale_data['total_price_per_date'] | currency: 'INR'}}</div>
                  <div class="col-3">{{sale_data['order_created_time'] | date: 'shortTime'}}</div>
                  <div class="col-2">
                    <i style="cursor: pointer; color: red;" class="material-icons"
                      (click)="deleteClicked(sale_data)">cancel</i>
                  </div>
                </div>
              </span>
              <div *ngIf="!sale_group_data.hasOwnProperty(user.login_id)"
                style="text-align: center; margin-bottom: 10px;">No customer order till now</div>
            </div>
            <div class="col-12">
              <hr style="background: white;">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="icustomer_verified" style="padding: 13px;margin-bottom: 51px;">
    <div class="row">
      <div class="col-7"
        style="margin-top: 15px; text-align: center; border: 2px solid grey; padding: 15px; border-radius: 10px; background: floralwhite;">
        <h4>Orders</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-7">
        <div class="card" *ngFor="let date_value of future_order,  let title_index=index;" style="margin-top: 10px;">
          <div style="padding: 5px;width: 100%;margin-top: 10px;" *ngIf="date_value['total_price_per_month']!= null"
            (click)="routeToDetailPage(date_value, title_index)">
            <span>
              <div class="row">
                <div class="col-1"></div>
                <div class="col">
                  <label style="font-weight: 600;">
                    {{monthNames[date_value['month'] - 1]}} {{date_value['year']}}</label>
                </div>
                <div class="col">
                  <label>Total Bill amount : <span style="font-weight: 600;">
                      {{date_value['total_price_per_month']}} </span></label>
                </div>
                <div class="col" *ngIf="date_value['current_date'] == date_value['order_date']">
                  <button mat-raised-button class="button-class" (click)="deleteClicked(date_value)">
                    Delete
                  </button>
                </div>
                <!-- <div class="col">
                  <label> Ordered Date : <b>{{date_value['order_date']| date: 'MMM, d'}}</b></label>
                </div> -->
                <div class="col-1">
                  <i class="material-icons" *ngIf="selected_index !== title_index">keyboard_arrow_down</i>
                  <i class="material-icons" *ngIf="selected_index === title_index">keyboard_arrow_up</i>
                </div>
              </div>
            </span>
          </div>
          <span *ngIf="selected_index === title_index">
            <div class="card" *ngIf="product_form_dict_for_future_order!= null" style="padding: 5px;color: black;">
              <div class="row" style="padding: 10px;">
                <div class="col-1"></div>
                <div class="col">
                  <b style="font-size: 18px; text-decoration: underline;">Order Details</b></div>
                <div class="col-3"> <button mat-raised-button class="button-class"
                    (click)="customerCardClikced(date_value)">Customer Card</button></div>
              </div>
              <div class="row">
                <div class="col-1"></div>
                <div class="col-5" *ngIf="month_and_year != null">
                  {{monthNames[month_and_year['month'] - 1]}} {{total_days_in_month}} days
                </div>
              </div>
              <div class="row" style="text-align: center;">
                <div class="col-1"></div>
                <div class="col-3"></div>
                <div class="col-2 text-center" *ngFor="let session of session_list">
                  {{session['display_name']}}
                </div>
                <div class="col-3 text-center">
                  <label> Price<br>(Per month)</label>
                </div>
              </div>
              <span>
                <span *ngFor="let product of product_list">
                  <div class="row"
                    *ngIf="icustomer_type_id == 2 && old_employee_product_list.includes(product.product_id)">
                    <div class="col-1"></div>
                    <div class="col-3">
                      {{product.product_short_name}}<br>
                    </div>
                    <div class="col-2 text-center" *ngFor="let session of session_list">
                      <label
                        *ngIf="product_form_dict_for_future_order['product'][session.id][product.product_id]['quantity'] !== null">
                        {{product_form_dict_for_future_order['product'][session.id][product.product_id]['quantity']}}</label>
                      <label
                        *ngIf="product_form_dict_for_future_order['product'][session.id][product.product_id]['quantity'] == null">
                        0
                      </label>
                    </div>
                    <div class="col-3 text-center" style="text-align: left;">
                      <label style="margin-left: 5%;">
                        {{product_form_dict_for_future_order['total_price_per_product_per_month'][product.product_id]}}
                      </label>
                    </div>
                  </div>
                  <div class="row" *ngIf="icustomer_type_id != 2">
                    <div class="col-1"></div>
                    <div class="col-3">
                      {{product.product_short_name}} <br>
                    </div>
                    <div class="col-2 text-center" *ngFor="let session of session_list">
                      <label
                        *ngIf="product_form_dict_for_future_order['product'][session.id][product.product_id]['quantity'] !== null">
                        {{product_form_dict_for_future_order['product'][session.id][product.product_id]['quantity']}}</label>
                      <label
                        *ngIf="product_form_dict_for_future_order['product'][session.id][product.product_id]['quantity'] == null">
                        0
                      </label>
                    </div>
                    <div class="col-3 text-center" style="text-align: left;">
                      <label style="margin-left: 5%;">
                        {{product_form_dict_for_future_order['total_price_per_product_per_month'][product.product_id]}}
                      </label>
                    </div>
                  </div>
                </span>
              </span>
              <div class="row">
                <div class="col-8" style="text-align: right;">
                  <label>Total price</label>
                </div>
                <div class="col-3 text-center" style="border-top: 1px solid; border-bottom: 1px solid;">
                  <label>{{product_form_dict_for_future_order['total_price_per_order'] | currency:'INR'}}</label>
                </div>
              </div>
            </div>
            <div class="row" *ngIf="business_details_for_future!=null" style="padding: 10px;">
              <div class="col-1"></div>
              <div class="col">
                <b>Booth Name : </b> {{business_details_for_future['name']}}<br>
                <b> Agent Name : </b> {{business_details_for_future['agent_first_name']}}
                {{business_details_for_future['agent_last_name']}}<br>
                <b>Mobile : </b> {{business_details_for_future['agent_mobile_number']}}<br>
                <b>Address : </b> {{business_details_for_future['address']}} ,
                {{business_details_for_future['location_category_value']}} ,
                {{business_details_for_future['location_category_name']}}
              </div>
              <div class="row">
              <div class="col">
                <b>Order Date : </b> {{date_value['order_date']| date: 'MMM d, y'}}<br>
                <b>Order By : </b> {{date_value['ordered_by_name']}}<br>
                <b>Order Via: </b> {{date_value['ordered_via_name']}}<br>
              </div>
            </div>
              <div class="col-3"> <button mat-raised-button class="button-class"
                  *ngIf="date_value['month'] > current_month_for_future_order_check && date_value['year'] >= current_year_for_future_order_check"
                  (click)="boothChangeClicked('after_order')">Change</button></div>
            </div>
          </span>

        </div>
        <hr>
      </div>
    </div>
  </div>
</section>
